import { render } from "./EditRedevancePage.vue?vue&type=template&id=6aa03d22&ts=true"
import script from "./EditRedevancePage.vue?vue&type=script&lang=ts"
export * from "./EditRedevancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__